import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import './CommentBoxInput.scss';

const CommentBoxInput = ({ placeholderText, handleChange }) => {
    const inputRef = useRef();
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [inputRef]);
    return (
        <div className="component-CommentBoxInput">
            <div className="componentBoxInput-TextArea">
                <form>
                    <textarea
                        name="commentBoxInput"
                        placeholder={placeholderText}
                        onChange={handleChange}
                        ref={inputRef}
                    />
                </form>
            </div>
        </div>
    );
};

CommentBoxInput.propTypes = {
    placeholderText: PropTypes.string,
    handleChange: PropTypes.func,
};

CommentBoxInput.defaultProps = {
    placeholderText: '',
    handleChange: () => {},
};

CommentBoxInput.displayName = 'CommentBoxInput';

export default CommentBoxInput;
